import AuthInputComponent from "./AuthInputComponent";

export default AuthInputComponent;
